<template>
  <Toast />
  <DataTable
    ref="dv"
    responsiveLayout="scroll"
    id="usuario"
    dataKey="usuario"
    :value="usuarios"
    :paginator="true"
    :rows="25"
    :loading="loading1"
    :filters="filters"
    showGridlines
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    :rowsPerPageOptions="[25, 50, 75, 100, 125]"
    currentPageReportTemplate="Viendo {first} a {last} de {totalRecords} usuarios"
  >
    <Toolbar class="p-mb-4"
      ><template v-slot:right>
        <Button
          label="Nuevo"
          icon="pi pi-plus"
          @click="registroNuevo"
          class="p-button-success p-mr-2"
        /> </template
    ></Toolbar>

    <template #empty><b>No se encontró ningún usuario.</b></template>
    <template #loading> Cargando la administracion de usuarios... </template>
    <Column
      field="id"
      header="No."
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column
      field="usuario"
      header="Usuario"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column
      field="nombre"
      header="Nombre de Usuario"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column
      field="fecha_creacion"
      header="Fecha Creacion"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>

    <Column
      field="ultima_actualizacion"
      header="Ultima Actualizacion"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column
      field="estatus"
      header="Estatus"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column
      field="dispositivo"
      header="Dispositivo Asociado"
      :sortable="true"
      style="min-width: 12rem"
    ></Column>
    <Column :exportable="false" style="min-width: 8rem">
      <template #body="slotProps">
        <Button
          icon="pi pi-pencil"
          class="p-button-rounded p-button-success p-mr-2"
          @click="updateLink(slotProps.data)"
        />
        <Button
          icon="pi pi-trash"
          class="p-button-rounded p-button-warning"
          @click="confirmDeleteUsuario(slotProps.data)"
        />
      </template>
    </Column>
  </DataTable>
  <Dialog
    v-model:visible="deleteProductDialog"
    :style="{ width: '450px' }"
    header="Confirmacion"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="product"
        >Esta seguro que desea eliminar el usuario <b>{{ product.usuario }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="deleteProductDialog = false"
      />
      <Button
        label="Si"
        icon="pi pi-check"
        class="p-button-text"
        @click="deleteProduct"
      />
    </template>
  </Dialog>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';

export default {
  data() {
    return {
      filters: null,
      loading1: true,
      isLoading: false,
      usuarios: null,
      deleteProductDialog: false,
    };
  },
  created() {
    this.initFilters();
    this.loadUsuarios();
  },
  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async loadUsuarios() {
      try {
        this.usuarios = await this.$store.dispatch('loadUsuarios');
        this.loading1 = false;
      } catch (error) {
        this.error = error.message || 'algo salió mal';
        this.loading1 = false;
      }
    },
    confirmDeleteUsuario(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    async deleteProduct() {
      ////console.log(this.product.cusname);
      ////console.log(this.product.cusnit);
      this.deleteProductDialog = false;

      const formData = {
        usuario: this.product.usuario,
        nombre: this.product.nombre,
        password: this.product.password,
        estatus: this.product.estatus,
        dispositivo: this.product.dispositivo,
      };
      const response = await this.$store.dispatch('deleteUsuarios', formData);
      console.log(response);
      console.log(response[0]);
      if (response[0].codigo == 1) {
        this.$toast.add({
          severity: 'success',
          summary: 'Eliminacion ',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Eliminacion',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
      }
      this.loadUsuarios();
    },
    registroNuevo() {
      const redirectUrl =
        '/' + (this.$route.query.redirect || 'insert/usuarios');
      this.$router.replace(redirectUrl);
    },
    updateLink(product) {
      console.log(product);
      const redirectUrl = this.$route.path + '/' + product.usuario;
      console.log(redirectUrl);
      this.$router.replace(redirectUrl);
    },
  },
};
</script>
